import { PaginationConfigProps, LocationData } from './types';

export function getPageLocations(locations: LocationData[], paginationConfig: PaginationConfigProps, locationsPerPage: number) {
  return locations.slice((paginationConfig.current - 1) * locationsPerPage, paginationConfig.current * locationsPerPage);
}
